import { QueryClient } from '@tanstack/react-query';

/**
 * Cliente global de React Query.
 * - staleTime 5 min: al volver a una página dentro de ese rango NO re-fetchea (instantáneo desde caché).
 * - gcTime 30 min: conserva los datos en caché aunque desmontes la página (navegar y volver = instantáneo).
 * - refetchOnWindowFocus false: no recargar solo por volver a la pestaña.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
